import React from 'react';

/**
 * RUF-564 — inline SiliconX brand marks for the passport PDF.
 * Generated from packages/shared/src/brand/logo-light.svg with fills
 * hardcoded (no <style> classes): PassportDocument must stay a
 * deterministic, zero-network static document, and inline SVG with
 * attribute fills is the only form that survives renderToStaticMarkup
 * without id/class collisions when the mark repeats per section.
 */

const MARK_POLYGONS: ReadonlyArray<readonly [fill: string, points: string]> = [
  ['#0a9355', '29.36 25.96 25.29 30.09 21.23 25.96 29.36 25.96'],
  ['#63df79', '29.36 25.96 21.23 25.96 25.29 21.83 29.36 25.96'],
  ['#025630', '44.47 17.35 44.14 17.68 39.14 22.77 32.92 22.77 30.67 20.48 33.67 17.44 33.84 17.27 33.84 17.35 44.47 17.35'],
  ['#0a9355', '50.66 11.05 44.47 17.35 33.84 17.35 33.84 17.27 40.03 11 40.03 11.05 50.66 11.05'],
  ['#10ac6c', '40.03 .21 40.03 11 33.84 17.27 33.84 17.27 33.81 6.56 33.07 7.3 36.39 3.91 40.03 .21'],
  ['#078a58', '33.84 17.27 33.67 17.44 30.67 20.48 28.52 18.28 28.52 11.94 33.07 7.31 33.07 7.3 33.81 6.56 33.84 17.27'],
  ['#4cc15c', '50.66 .21 50.66 11.05 40.03 11.05 40.03 11 50.66 .21'],
  ['#63df79', '50.66 .21 40.03 11 40.03 .21 50.66 .21'],
  ['#025630', '16.82 6.31 17.15 6.64 22.15 11.73 22.15 18.07 19.9 20.35 16.92 17.31 16.74 17.13 16.82 17.13 16.82 6.31'],
  ['#0a9355', '10.64 0 16.82 6.3 16.82 17.13 16.74 17.13 10.59 10.83 10.64 10.83 10.64 0'],
  ['#10ac6c', '0 10.83 10.59 10.83 16.74 17.13 16.74 17.13 6.23 17.16 6.96 17.91 3.63 14.53 0 10.83'],
  ['#078a58', '16.74 17.13 16.92 17.31 19.9 20.35 17.74 22.55 11.51 22.55 6.97 17.91 6.96 17.91 6.23 17.16 16.74 17.13'],
  ['#4cc15c', '0 0 10.64 0 10.64 10.83 10.59 10.83 0 0'],
  ['#63df79', '0 0 10.59 10.83 0 10.83 0 0'],
  ['#025630', '6.19 34.78 6.52 34.45 11.51 29.36 17.74 29.36 19.98 31.65 16.99 34.69 16.82 34.87 16.82 34.78 6.19 34.78'],
  ['#0a9355', '0 41.08 6.19 34.78 16.82 34.78 16.82 34.87 10.63 41.13 10.63 41.08 0 41.08'],
  ['#10ac6c', '10.63 51.92 10.63 41.13 16.82 34.87 16.82 34.87 16.85 45.57 17.59 44.83 14.27 48.22 10.63 51.92'],
  ['#078a58', '16.82 34.87 16.99 34.69 19.98 31.65 22.14 33.85 22.14 40.19 17.59 44.82 17.59 44.83 16.85 45.57 16.82 34.87'],
  ['#4cc15c', '0 51.92 0 41.08 10.63 41.08 10.63 41.13 0 51.92'],
  ['#63df79', '0 51.92 10.63 41.13 10.63 51.92 0 51.92'],
  ['#025630', '33.83 45.82 33.5 45.49 28.51 40.4 28.51 34.07 30.76 31.78 33.74 34.82 33.91 35 33.83 35 33.83 45.82'],
  ['#0a9355', '40.02 52.13 33.83 45.83 33.83 35 33.91 35 40.07 41.3 40.02 41.3 40.02 52.13'],
  ['#10ac6c', '50.66 41.3 40.07 41.3 33.91 35 33.91 35 44.43 34.97 43.7 34.22 47.02 37.6 50.66 41.3'],
  ['#078a58', '33.91 35 33.74 34.82 30.76 31.78 32.91 29.58 39.14 29.58 43.69 34.22 43.7 34.22 44.43 34.97 33.91 35'],
  ['#4cc15c', '50.66 52.13 40.02 52.13 40.02 41.3 40.07 41.3 50.66 52.13'],
  ['#63df79', '50.66 52.13 40.07 41.3 50.66 41.3 50.66 52.13'],
];

const WORDMARK_PATHS: readonly string[] = [
  'M77.67,43.02c-2.64,0-4.9-.45-6.79-1.36-1.89-.9-3.37-2.17-4.43-3.81-1.06-1.63-1.66-3.56-1.8-5.78l6.57-.31c.17,1.23.52,2.27,1.05,3.13.53.86,1.25,1.51,2.15,1.95s2.01.66,3.33.66c1.09,0,2.01-.13,2.77-.39s1.34-.66,1.74-1.2.6-1.2.6-1.99c0-.73-.17-1.36-.52-1.9-.34-.54-1-1.04-1.98-1.49s-2.41-.9-4.3-1.33c-2.61-.61-4.71-1.3-6.29-2.06s-2.74-1.71-3.46-2.87c-.72-1.15-1.07-2.6-1.07-4.35,0-1.87.45-3.5,1.35-4.9s2.21-2.49,3.93-3.28c1.72-.79,3.77-1.18,6.14-1.18,2.52,0,4.65.45,6.4,1.36s3.12,2.14,4.1,3.72,1.58,3.38,1.78,5.43l-6.53.35c-.09-1.08-.37-2.02-.86-2.82s-1.15-1.42-1.98-1.86c-.83-.44-1.83-.66-3.01-.66-1.49,0-2.66.34-3.5,1.01-.85.67-1.27,1.55-1.27,2.62,0,.76.19,1.39.58,1.9s1.03.96,1.93,1.33,2.18.74,3.85,1.09c2.83.58,5.08,1.32,6.72,2.21,1.65.89,2.81,1.95,3.5,3.17s1.03,2.63,1.03,4.2c0,1.93-.48,3.6-1.44,5.01-.96,1.42-2.32,2.5-4.08,3.26-1.76.76-3.85,1.14-6.25,1.14Z',
  'M92.63,15.97v-5.25h6.66v5.25h-6.66ZM92.76,42.32v-23.46h6.45v23.46h-6.45Z',
  'M109.56,42.32c-1.89,0-3.37-.48-4.43-1.44-1.06-.96-1.59-2.52-1.59-4.68V11.24h6.45v24.25c0,.7.16,1.2.47,1.49.31.29.77.44,1.38.44h1.55v4.9h-3.82Z',
  'M115.44,15.97v-5.25h6.66v5.25h-6.66ZM115.57,42.32v-23.46h6.45v23.46h-6.45Z',
  'M136.58,42.84c-2.35,0-4.4-.5-6.14-1.51-1.75-1.01-3.11-2.43-4.08-4.27-.97-1.84-1.46-4-1.46-6.48s.49-4.63,1.46-6.46c.97-1.82,2.33-3.25,4.08-4.27,1.75-1.02,3.79-1.53,6.14-1.53,2.03,0,3.86.37,5.48,1.09s2.93,1.78,3.93,3.15c1,1.37,1.62,3.02,1.85,4.95l-6.66.31c-.2-1.46-.71-2.56-1.52-3.3s-1.84-1.12-3.07-1.12c-1.6,0-2.85.63-3.74,1.88-.89,1.25-1.33,3.02-1.33,5.29s.44,4.05,1.33,5.32c.89,1.27,2.13,1.9,3.74,1.9,1.23,0,2.26-.39,3.09-1.16.83-.77,1.33-1.95,1.5-3.52l6.66.26c-.2,1.93-.79,3.6-1.78,5.01-.99,1.42-2.29,2.51-3.91,3.28s-3.47,1.16-5.56,1.16Z',
  'M160.77,42.84c-2.35,0-4.4-.5-6.14-1.51-1.75-1.01-3.11-2.43-4.08-4.27-.97-1.84-1.46-4-1.46-6.48s.49-4.63,1.46-6.46c.97-1.82,2.33-3.25,4.08-4.27,1.75-1.02,3.79-1.53,6.14-1.53s4.4.51,6.14,1.53,3.11,2.44,4.08,4.27,1.46,3.98,1.46,6.46-.49,4.64-1.46,6.48c-.97,1.84-2.33,3.26-4.08,4.27-1.75,1.01-3.8,1.51-6.14,1.51ZM160.77,37.81c1.6,0,2.85-.63,3.74-1.9.89-1.27,1.33-3.04,1.33-5.32s-.44-4.05-1.33-5.32c-.89-1.27-2.13-1.9-3.74-1.9s-2.85.63-3.74,1.9c-.89,1.27-1.33,3.04-1.33,5.32s.44,4.05,1.33,5.32c.89,1.27,2.13,1.9,3.74,1.9Z',
  'M174.52,42.32v-23.46h5.8l.26,6.87-.82-.22c.23-1.75.69-3.15,1.4-4.2.7-1.05,1.58-1.81,2.64-2.28,1.06-.47,2.22-.7,3.48-.7,1.66,0,3.07.37,4.23,1.09s2.05,1.76,2.66,3.08c.62,1.33.92,2.9.92,4.7v15.1h-6.44v-12.91c0-1.25-.1-2.32-.3-3.19-.2-.88-.56-1.54-1.07-1.99s-1.23-.68-2.15-.68c-1.35,0-2.38.5-3.09,1.51-.72,1.01-1.07,2.46-1.07,4.35v12.91h-6.45Z',
  'M201.25,42.32l10.36-15.58-10.27-15.49h7.56l6.66,10.46,6.49-10.46h7.61l-10.27,15.41,10.4,15.67h-7.61l-6.7-10.63-6.62,10.63h-7.61Z',
];

function MarkShapes() {
  return (
    <>
      {MARK_POLYGONS.map(([fill, points], i) => (
        <polygon key={i} fill={fill} points={points} />
      ))}
    </>
  );
}

/** Icon-only mark (the pinwheel), for section headings. */
export function SiliconXMark({ size = 11 }: { size?: number }) {
  return (
    <svg viewBox="0 0 50.66 52.13" width={size} height={size} aria-hidden="true">
      <MarkShapes />
    </svg>
  );
}

/** Full logo: mark + SiliconX wordmark. */
export function SiliconXLogo({ height = 24 }: { height?: number }) {
  return (
    <svg
      viewBox="0 0 229.78 52.13"
      height={height}
      width={Math.round(height * (229.78 / 52.13))}
      role="img"
      aria-label="SiliconX"
    >
      <MarkShapes />
      <g fill="#16181d">
        {WORDMARK_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
    </svg>
  );
}
